import React from 'react';
import { observer } from 'mobx-react';
import { Box, Button, Typography } from '@mui/material';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { CampaignData } from './types';

const CampaignDetails:React.FC<{ campaignData: CampaignData }> = ({ campaignData }) => (
  <Box display="flex" flexDirection="column" gap={1} alignItems="flex-start" height="100%">
    {campaignData.icon}
    <Typography fontSize={18} fontWeight={500}>
      {campaignData.title}
    </Typography>
    <Typography fontSize={14} fontWeight={400} color="#807E7E">
      {campaignData.description}
    </Typography>
    <Button
      onClick={(e) => {
        e.stopPropagation();
        campaignData.action?.();
      }}
      variant="text"
      disableRipple
      sx={{
        color: '#000', fontSize: 16, mt: 'auto', p: 0, '&:hover': { background: 'none' },
      }}
    >
      {campaignData.buttonText}
      <ArrowForwardIcon fontSize="large" />
    </Button>
  </Box>
);

export default observer(CampaignDetails);
